module.exports = __webpack_public_path__ + "static/media/visa.9c4a7acd.svg";